// extracted by mini-css-extract-plugin
export default {"container":"DisplayBadge_container__AcvEb","WAIT":"DisplayBadge_WAIT__6k8et","CLOSE":"DisplayBadge_CLOSE__To0Dr"};